export default __webpack_public_path__ + "static/media/affligem_background_s1.71936cb4.jpg";